import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft } from "lucide-react";
import { BRAND } from "@/data/content";

const PaymentCancel = () => (
  <div className="min-h-screen bg-[#0A1428] text-white flex items-center justify-center px-5 relative overflow-hidden">
    <div className="hero-orb absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full" />
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="w-full max-w-lg rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-10 md:p-12 text-center"
      data-testid="payment-cancel-card"
    >
      <div className="flex items-center justify-center gap-3 mb-8">
        <img src={BRAND.logo} alt={BRAND.name} className="h-11 w-11 rounded-lg object-contain" />
        <span className="font-display font-bold text-lg">TITAN<span className="text-[#1E6BFF]">.</span></span>
      </div>
      <XCircle size={48} className="text-gray-400 mx-auto mb-6" />
      <h1 className="font-display font-bold text-3xl mb-3">Checkout cancelled</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        No charge was made. If you changed your mind or ran into an issue, we're happy to help.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 items-center justify-center">
        <Link
          to="/#pricing"
          data-testid="cancel-pricing-link"
          className="inline-flex items-center gap-2 rounded-full bg-[#1E6BFF] hover:bg-[#3B82F6] text-white font-semibold px-6 py-3 transition-colors duration-200"
        >
          Back to pricing
        </Link>
        <Link
          to="/#contact"
          data-testid="cancel-contact-link"
          className="inline-flex items-center gap-2 rounded-full border border-white/20 hover:border-white/50 text-white font-semibold px-6 py-3 transition-colors duration-200"
        >
          <ArrowLeft size={16} /> Send us a message instead
        </Link>
      </div>
    </motion.div>
  </div>
);

export default PaymentCancel;
